import { FC } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface ICityStateZipLine {
  city?: string;
  state?: string;
  zipCode?: string;
}

/**
 * The city/state/zip line of an address, shared by the pickup and the delivery
 * block so the two cannot drift apart on separator — they had, one joining with
 * a comma and the other with a space.
 *
 * Parts are optional-chained everywhere upstream, so an address can arrive with
 * none of them; the line is omitted rather than rendered blank.
 */
export const CityStateZipLine: FC<ICityStateZipLine> = ({ city, state, zipCode }) => {
  const line = [city, state, zipCode].filter(Boolean).join(', ');

  if (!line) {
    return null;
  }

  return <Typography variant="body-sm">{line}</Typography>;
};
